var map = {
	"./algo-img-0.bc184c8.jpg": "GPIw",
	"./algo-img-0.jpg": "Sg3R",
	"./algo-img-1.3095bf4.jpg": "E38O",
	"./algo-img-1.jpg": "jMn6",
	"./algo-img-2.272e8c9.jpg": "vUK9",
	"./algo-img-2.jpg": "XMSp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e21y";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/algo\-img\-.*\.jpg$
// module id = e21y
// module chunks = 2